import React from 'react'
import { Typography, Grid, makeStyles } from '@material-ui/core'
import FaceIcon from '@material-ui/icons/Face'
import { grey } from '@material-ui/core/colors'
import { useTranslation } from 'react-i18next'

const styles = makeStyles({
  container: {
    textAlign: 'center',
  },
  icon: {
    width: '50px',
    height: '50px',
  },
  subheadline: {
    color: grey[700],
  },
  headline: {
    color: grey[900],
  },
})

const EmptyState = () => {
  const { t } = useTranslation()
  const classes = styles()

  return (
    <Grid container alignItems="center" className={classes.container}>
      <Grid xs={12} item>
        <FaceIcon className={classes.icon} />
      </Grid>

      <Grid xs={12} item>
        <Typography className={classes.headline} variant="h4">
          {t('text_no_data_available')}
        </Typography>
      </Grid>

      <Grid xs={12} item>
        <Typography className={classes.subheadline}>{t('text_select_practitioner')}</Typography>
      </Grid>
    </Grid>
  )
}

export default EmptyState
